// designer-model.js

import { Model } from 'backbone';
import Immutable from 'immutable';
import themeService from 'ThemeService.js';

//================================================================================================
// - Theme-instrumented "get" method
// -- Lou Mauget, Feburary 1, 2016
//================================================================================================
class DesignerModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    //================================================================================================
    // Theme-resident values are theme function return values.
    // "Hard" values are ... not.
    //
    // A themed value begins with tilde '~';
    //
    // Changing a themed value changes the corresponding model "get" value, provided that the model
    // attribute still points to the theme value for it. Otherwise, the returned value
    // is business-as-usual. The user must have carried out an overriding set of that property.
    //================================================================================================
    get(prop)  {
        const val = super.get( prop );
        return (val && typeof val === 'string' && val.length > 0 && val.charAt(0) === '~')
            ? themeService.resolve( val ) // It's a theme value
            : val;
    }


    parse(response, options)  {
        return response;
    }
}


export default DesignerModel;
